import {
  AfterViewInit,
  Directive,
  ElementRef,
  Input,
  OnChanges,
  Renderer2,
  SimpleChanges,
} from '@angular/core';

/**
 * Format for configurable flexbox
 * @example
 *   {
 *      "direction": "row",
 *      "alignItems": "center",
 *      "justifyContent": "space-between"
 *   }
 */
export interface UIFlexboxConfig {
  direction: 'row' | 'column';
  alignItems: 'center' | 'flex-end' | 'space-between';
  justifyContent: 'center' | 'flex-end' | 'space-between';
}

/**
 * Sets CSS flexbox properties for a given HTML element based on configuration
 * @example
 *   <div [ui-flexbox]="config.flexbox"></div>
 */
@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[ui-flexbox]',
})
export class UIFlexboxDirective implements AfterViewInit, OnChanges {
  @Input('ui-flexbox') config!: UIFlexboxConfig;

  constructor(
    private elementRef: ElementRef,
    private renderer: Renderer2,
  ) {}

  ngAfterViewInit() {
    this.applyStyles();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes) {
      this.applyStyles();
    }
  }

  applyStyles() {
    const el = this.elementRef.nativeElement;

    this.renderer.setStyle(el, 'display', 'flex');
    this.renderer.setStyle(el, 'flex-direction', this.config.direction);
    this.renderer.setStyle(el, 'align-items', this.config.alignItems);
    this.renderer.setStyle(el, 'justify-content', this.config.justifyContent);
  }
}
